import React, { Component } from 'react';
import { Spin } from 'antd';
import styles from './spinner.module.less';

export default class Spinner extends Component {
  render() {
    return <Spin size="large" className={styles.spining} />;
  }
}
